"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("./state"));
var evolve_emitter_1 = __importDefault(require("../emitters/evolve-emitter"));
var color_1 = require("../utilities/color");
var stack_container_1 = __importStar(require("../views/stack-container"));
var game_area_1 = require("../utilities/game-area");
var gsap_1 = require("gsap");
var guide_1 = require("../models/guide");
var i18next_1 = __importDefault(require("i18next"));
var random_1 = require("../utilities/random");
var guide_state_1 = __importDefault(require("./guide-state"));
var EvolveState = /** @class */ (function (_super) {
    __extends(EvolveState, _super);
    function EvolveState(app, client, guide, backdropContainer, dragonContainer) {
        var _this = _super.call(this) || this;
        _this._app = app;
        _this._client = client;
        _this._guide = guide;
        _this._backdropContainer = backdropContainer;
        _this._dragonContainer = dragonContainer;
        return _this;
    }
    Object.defineProperty(EvolveState.prototype, "evolveEmitter", {
        get: function () {
            if (!this._evolveEmitter) {
                this._evolveEmitter = new evolve_emitter_1.default();
            }
            return this._evolveEmitter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvolveState.prototype, "titleLabel", {
        get: function () {
            if (!this._titleLabel) {
                this._titleLabel = new PIXI.Text("");
                this._titleLabel.style = {
                    fontFamily: "Arial",
                    fontWeight: "bold",
                    align: "center",
                    fontSize: 35,
                    fill: color_1.COLOR.WHITE
                };
            }
            return this._titleLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvolveState.prototype, "tipLabel", {
        get: function () {
            if (!this._tipLabel) {
                this._tipLabel = new PIXI.Text("");
                this._tipLabel.style = {
                    fontFamily: "Arial",
                    fontSize: 21,
                    fill: color_1.COLOR.GREEN
                };
            }
            return this._tipLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvolveState.prototype, "stackContainer", {
        get: function () {
            if (!this._stackContainer) {
                this._stackContainer = new stack_container_1.default([
                    this.titleLabel,
                    this.tipLabel
                ], {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 6,
                    minWidth: game_area_1.GAME_WIDTH
                });
                this._stackContainer.position.set(0, game_area_1.GAME_SAFE_AREA.bottom - this._stackContainer.height - 10);
            }
            return this._stackContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvolveState.prototype, "evolution", {
        get: function () {
            return this._evolution;
        },
        set: function (value) {
            this._evolution = value;
        },
        enumerable: false,
        configurable: true
    });
    EvolveState.prototype.didEnterFrom = function (previousState) {
        _super.prototype.didEnterFrom.call(this, previousState);
        this._app.stage.addChild(this._backdropContainer);
        this._app.stage.addChild(this.evolveEmitter.parent);
        this._app.stage.addChild(this.stackContainer);
        this._dragonContainer.interactive = true;
        this._dragonContainer.on("pointerdown", this.evolveDragon.bind(this));
        this._dragonContainer.setIdleAnimation();
        this._backdropContainer.dragonSlot.addChild(this._dragonContainer);
        this.titleLabel.text = i18next_1.default.t("evolve_caption");
        this.tipLabel.text = i18next_1.default.t("evolve_hint");
        this.stackContainer.layoutChildren();
        this._client.sendEvent("evolve_entered");
    };
    EvolveState.prototype.willExitTo = function (nextState) {
        _super.prototype.willExitTo.call(this, nextState);
        this._app.stage.removeChild(this._backdropContainer);
        this._app.stage.removeChild(this.evolveEmitter.parent);
        this._app.stage.removeChild(this.stackContainer);
        this.evolveEmitter.emit = false;
        this.evolveEmitter.cleanup();
        this._dragonContainer.interactive = false;
        this._dragonContainer.off("pointerdown");
        this._backdropContainer.dragonSlot.removeChild(this._dragonContainer);
    };
    EvolveState.prototype.evolveDragon = function () {
        this._dragonContainer.interactive = false;
        var evolvePosition = this._app.stage.toLocal(new PIXI.Point(0, -300), this._dragonContainer);
        this.evolveEmitter.updateSpawnPos(evolvePosition.x, evolvePosition.y);
        this.evolveEmitter.emit = true;
        this.titleLabel.text = "";
        this.tipLabel.text = "";
        this.stackContainer.layoutChildren();
        gsap_1.gsap.to(this, {
            duration: 1,
            onComplete: this.finished.bind(this)
        });
    };
    EvolveState.prototype.finished = function () {
        var e_1, _a;
        var _this = this;
        this.evolveEmitter.emit = false;
        var pages = [];
        var _loop_1 = function () {
            var elementIDs = this_1.evolution.rewards[categoryID];
            var unlockedElementIDs = this_1._client.dragon.unlocks[categoryID];
            unlockedElementIDs.push.apply(unlockedElementIDs, __spreadArray([], __read(elementIDs), false));
            var currentElementID = this_1._client.dragon.appearance[categoryID];
            var differentElementIDs = unlockedElementIDs.filter(function (elementID) { return elementID != currentElementID; });
            this_1._client.dragon.appearance[categoryID] = (0, random_1.randomValue)(differentElementIDs);
            pages.push([
                new guide_1.GuideMessage(i18next_1.default.t("guide_evolve_1") + ":"),
                new guide_1.GuideMessage(i18next_1.default.t(categoryID), guide_1.GUIDE_MESSAGE_TYPE.IMPORTANT),
                new guide_1.GuideMessage(i18next_1.default.t("guide_evolve_2") + ": " + unlockedElementIDs.length)
            ]);
        };
        var this_1 = this;
        try {
            for (var _b = __values(Object.keys(this.evolution.rewards)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var categoryID = _c.value;
                _loop_1();
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this._client.dragon.status.stage = this.evolution.stage;
        this._client.synchronize();
        this._client.sendEvent("evolve_finished", {
            stage: this.evolution.stage
        });
        gsap_1.gsap.to(this, {
            duration: 1,
            onComplete: function () {
                _this._guide.setPages(pages);
                _this.stateMachine.pop();
                _this.stateMachine.push(guide_state_1.default);
            }
        });
    };
    return EvolveState;
}(state_1.default));
exports.default = EvolveState;
